import React, { useRef, useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

import RiskAction from '../../../actions/v2/risk';
import { UPDATE_RISK_TAGS } from '../../../constants'

import './index.css';

import LanguageService from "../../../services/languageService";
const languageService = new LanguageService;

function RiskTagsDropdown(props) {
  const { riskRow, translations, disabled } = props;
  const { add_a_tag } = translations;
  const [risk, setRisk] = useState({...riskRow});
  const risk_tags_options = languageService.translateRiskTagOptions(translations);

  const dropdown_ref = useRef();
  const dropdown_classname = disabled ?  "risk-tags-dropdown readonly" : "risk-tags-dropdown";

  const onUpdateRiskTags = (evt, data) => {
    risk.tag_list = data.value;
    setRisk(risk)

    const { id, plan_id } = risk;
    const updated_risk = {  id, plan_id, tag_list: data.value };
    props.updateRiskTags(updated_risk);
  }

  const synchRiskFromResponse = () => {
    const { id, tag_list } = props.risk.risk;

    if (risk.id !== id) return;

    risk.tag_list = tag_list;
    setRisk(risk);
  }

  const resetToOriginalRisk = () => {
    if (risk.id !== riskRow.id) return;
    setRisk({...riskRow});
  }

  useEffect(()=>{
    switch (props.risk.action_type) {
      case UPDATE_RISK_TAGS.success:
        return synchRiskFromResponse();
      case UPDATE_RISK_TAGS.failure:
        return resetToOriginalRisk();
      default: return;
    }
  }, [props.risk.action_type])

  useEffect(() => {
    setRisk(riskRow)
  }, [riskRow])

  return (
    <Dropdown
      ref={dropdown_ref}
      className={dropdown_classname}
      placeholder={add_a_tag}
      options={risk_tags_options}
      value={risk.tag_list}
      onChange={onUpdateRiskTags}
      closeOnBlur={true}
      closeOnChange={true}
      disabled={disabled}
      fluid
      multiple
      selection
      >
    </Dropdown>
  )
}

const mapStateToProps = (state) => {
  return {
    translations: state.language.language.translations,
    risk: state.risk
  }
}

const mapDispatchToProps = (dispatch) => {
  const riskAction = new RiskAction();

  return {
    updateRiskTags: (risk) => {
      dispatch(riskAction.updateRiskTags(risk))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskTagsDropdown);


// WEBPACK FOOTER //
// ./src/views/plan_tables/formatters/risk_tags_dropdown.js